import * as React from "react";
import { Layout, Menu, Icon } from "antd";
import { WrappedComponentProps, injectIntl } from "react-intl";
import "./PlatformLayout.less";
import { SwitchAccountButton } from "../Account/SwitchAccountButton";
import { LogoutButton } from "../LogoutButton";
import { SelectParam } from "antd/lib/menu";

const { Sider } = Layout;

interface Props extends WrappedComponentProps {
  pages: LayoutPageProps[];
  defaultSelectedPage?: string;
}

interface LayoutPageNavigationDetails {
  title: string;
  icon: string;
}

interface LayoutPageProps {
  key: string;
  navigationDetails: LayoutPageNavigationDetails;
  page: React.ReactNode;
}

interface State {
  selectedPage: string;
}

class PlatformLayoutCmp extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const selectedPage = props.defaultSelectedPage ? props.defaultSelectedPage : "1";
    this.state = {
      selectedPage
    };
  }

  public render() {
    return (
      <div className="App">
        <Layout className="platform-layout">
          <Sider className="platform-sider" breakpoint="lg" collapsedWidth="0">
            <img src="/images/axi-logo-small.png" width="200px" height="62px" style={{ display: "block", margin: "8px auto" }} alt="axi" />
            <Menu
              theme="dark"
              mode="inline"
              defaultSelectedKeys={[this.state.selectedPage]}
              onSelect={(item) => this.onMenuSelect(item)}
            >
              { this.props.pages.map(x => {
                return (
                  <Menu.Item key={x.key}>
                    <Icon type={x.navigationDetails.icon} />
                    <span className="nav-text">{x.navigationDetails.title}</span>
                  </Menu.Item>
                );
              })}
            </Menu>
            <Layout className="platform-sider-buttons">
              <SwitchAccountButton type="primary" block />
              <LogoutButton type="danger" block />
            </Layout>
          </Sider>
          <Layout>
            { this.props.pages.find(x => x.key === this.state.selectedPage)!.page }
          </Layout>
        </Layout>
      </div>
    );
  }

  private onMenuSelect(item: SelectParam) {
    this.setState({
      selectedPage: item.key
    });
  }
}

export const PlatformLayout = injectIntl(PlatformLayoutCmp);
